import React, { Component, createRef } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import NotificationProvider from "./components/notification/context";
import ThemeProvider from "./components/theme";
import createStore from "./store";
import apolloClient from "./lib/apollo";
import Routes from "./components/routes";
import { ApolloContextProvider } from "apollo";

import "./App.css";
import "./styles/tailwind.css";
import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const store = createStore();

class App extends Component {
  mapSideRef = createRef();

  render() {
    return (
      <Router>
        <ApolloContextProvider>
          <ApolloProvider client={apolloClient}>
            <Provider store={store}>
              <NotificationProvider>
                <ThemeProvider>
                  <Routes />
                </ThemeProvider>
              </NotificationProvider>
            </Provider>
          </ApolloProvider>
        </ApolloContextProvider>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js